module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadControl', {
    ref: "headControl",
    attrs: {
      "titleName": '设计数据'
    },
    on: {
      "changeVal": _vm.changeVal,
      "changDate": _vm.changDate,
      "changePicker": _vm.changePicker
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "top"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "chart_box"
  }, [_c('div', {
    staticClass: "chart_left"
  }, _vm._l((_vm.reportList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "left-t"
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('img', {
      attrs: {
        "src": item.itemIcon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_c('div', {
      staticClass: "a-title"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), (item.itemName.includes('金额')) ? _c('div', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(_vm.aFormat(item.amount))), _c('span', [_vm._v("元")])]) : _vm._e(), _vm._v(" "), (item.itemName.includes('数量')) ? _c('div', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(item.count)), _c('span', [_vm._v("个")])]) : _vm._e()])])
  }), 0), _vm._v(" "), _c('div', {
    ref: "progressData",
    staticClass: "progressData"
  }), _vm._v(" "), _c('div', {
    staticClass: "projectArea"
  }, [_c('div', {
    staticClass: "p_title"
  }, [_vm._v("项目地区")]), _vm._v(" "), _vm._l((_vm.designRegionData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "areaWrap"
    }, [_c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "left"
    }, [_c('div', {
      staticClass: "location"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "number"
    }, [_c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.count))]), _vm._v("个\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('img', {
      attrs: {
        "src": item.itemIcon
      }
    })])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "chart_box"
  }, [_c('div', {
    staticClass: "pieChart"
  }, [_c('div', {
    staticClass: "abnormalTotal"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("异常总数")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.abnormalTotal))]), _vm._v("个")])]), _vm._v(" "), _c('div', {
    ref: "abnormalData",
    staticClass: "abnormalData"
  })]), _vm._v(" "), _c('div', {
    ref: "abnormalType",
    staticClass: "abnormalType"
  })])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "partTitle_box"
  }, [_c('span', {
    staticClass: "partTitle"
  }, [_vm._v("进度数据")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "partTitle_box"
  }, [_c('div', {
    staticClass: "partTitle"
  }, [_vm._v("异常数据")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b31a80e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/designData/designData.vue
// module id = 1670
// module chunks = 471